export default __webpack_public_path__ + "static/media/29.0f4b6973.png";